import {
	GET_TYPE_INCIDENCES,
	GET_TYPE_INCIDENCES_ERROR,
	GET_TYPE_INCIDENCES_ERROR_SHOW,
	GET_TYPE_INCIDENCES_SUCCESS,
} from './../../constants';

export const getTypeIncidencesReducer = (state, actions) => {
	switch (actions.type) {
		case GET_TYPE_INCIDENCES:
			return {
				...state,
				loading: true,
			};
		case GET_TYPE_INCIDENCES_ERROR:
			return {
				incidences: state.incidences,
				//	collaboratorsOptions: state.collaboratorsOptions,
				loading: false,
				error: actions.payload,
				errorShow: false,
			};
		case GET_TYPE_INCIDENCES_SUCCESS:
			return {
				incidences: actions.payload,
				//collaboratorsOptions: getCollaboratorOptions(actions.payload),
				loading: false,
				error: null,
				errorShow: false,
			};
		case GET_TYPE_INCIDENCES_ERROR_SHOW:
			return {
				...state,
				errorShow: true,
			};
		default:
			return state;
	}
};
